import React, { useState, useRef, useEffect } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Button } from 'primereact/button';
import { Dropdown } from 'primereact/dropdown';
import { FilterMatchMode, FilterOperator } from 'primereact/api';
import { Column } from 'primereact/column';
import { DataTable } from 'primereact/datatable';
import { addLocale } from 'primereact/api'
import Base64Downloader from 'common-base64-downloader-react';
import apis from '../../api';
import { Dialog } from 'primereact/dialog';
import { Toast } from 'primereact/toast';
import { DataScroller } from 'primereact/datascroller';
import './DataScrollerDemo.css';
import useParamsRetefuente from '../../helpers/useParamsRetefuente'
import { InputText } from 'primereact/inputtext';
import { Toolbar } from 'primereact/toolbar';
import SkeletonTable from '../SkeletonTable/SkeletonTable';

/* =============================================================================
Remuner software (c)
Vibe Consulting.
Componente : Accounting
Description : Generación de reporte.
Date Autor Modification
================================================================================
04/11/2021 Cristian Andres Pizo Mina Creación 
05/4/2022 Cristian Andres Pizo Mina - Comentarios
================================================================================ */

export default function Retefuente(props) {

    // declaración de constantes
    const [contenido, setContenido] = useState("")
    // const [generado, setGenerado] = useState(false)
    const toast = useRef(null);
    const [params] = useParamsRetefuente();
    const [isOpen, setIsOpen] = React.useState(false);
    const [loading1, setLoading1] = useState(false);
    const [loading2, setLoading2] = useState(false);
    const [loading3, setLoading3] = useState(false);
    const [loadPage, setLoadPage] = useState(false);
    const [rowStateFile, setRowStateFile] = useState({});
    const [rowStateMail, setRowStateMail] = useState({});
    const [correo, setCorreo] = useState(localStorage.getItem('user') ? localStorage.getItem('user') : "")
    const [retefuente, setRetefuente] = useState({
        ENTITY: localStorage.getItem('entity'),
        CLIENT: localStorage.getItem('client'),
        NUMBER_ID: '',
        CONTRACT_ID: '',
        YEAR: '',
    });
    const elementWidth = { width: "60% ", marginRight: "1.5rem" };
    const headers = { authorization: localStorage.getItem('token') }
    const [listRetefuente, setListRetefuente] = useState([]);

    /*Propiedades de la tabla del componente*/
    // const [rowData, setRowData] = useState([]);
    const [rows, setRows] = useState([]);
    const [first2, setFirst2] = useState(0);
    const [rows2, setRows2] = useState(10);
    const [selectedRows, setSelectedRows] = useState(null);
    // const [filters1, setFilters1] = useState(null);
    const [globalFilterValue1, setGlobalFilterValue1] = useState('');

    // Nombre de lista de comprobantes
    useEffect(() => {
        let name = [{ name: 'Reporte retención en la fuente' }]
        setListRetefuente(name);
    }, []);

    useEffect(() => {
        if ((localStorage.getItem('type') === 'CLIENT' || localStorage.getItem('type') === 'APPROVER') && localStorage.getItem('number_id')) {
            let payload = {
                ENTITY: localStorage.getItem('entity'),
                CLIENT: localStorage.getItem('client'),
                NUMBER_ID: localStorage.getItem('number_id'),
                CONTRACT_ID: localStorage.getItem('contract_id'),
                YEAR: '',
            }
            try {
                setTabla(payload)
            }
            catch (err) {
                toast.current.show({ severity: 'warn', summary: 'Aviso', detail: err.response.data.message, life: 4000 })
            }
        }
    }, [])

    // Idioma del componente Calendar
    addLocale('es', {
        firstDayOfWeek: 1,
        dayNames: ['domingo', 'lunes', 'martes', 'miércoles', 'jueves', 'viernes', 'sábado'],
        dayNamesShort: ['dom', 'lun', 'mar', 'mié', 'jue', 'vie', 'sáb'],
        dayNamesMin: ['D', 'L', 'M', 'X', 'J', 'V', 'S'],
        monthNames: ['enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio', 'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre'],
        monthNamesShort: ['ene', 'feb', 'mar', 'abr', 'may', 'jun', 'jul', 'ago', 'sep', 'oct', 'nov', 'dic'],
        today: 'Hoy',
        clear: 'Claro'
    });

    /*Funciones que manejan el comportamiento de la tabla del componente*/
    const onCustomPage2 = (event) => {
        setFirst2(event.first);
        setRows2(event.rows);
    }

    const template2 = {
        layout: 'RowsPerPageDropdown CurrentPageReport PrevPageLink NextPageLink',
        'RowsPerPageDropdown': (options) => {
            const dropdownOptions = [
                { label: 5, value: 5 },
                { label: 10, value: 10 },
                { label: 20, value: 20 }
            ];

            return (
                <React.Fragment>
                    <span className="mx-1" style={{ color: 'var(--text-color)', userSelect: 'none' }}>Elementos por página: </span>
                    <Dropdown className="sel" value={options.value} options={dropdownOptions} onChange={options.onChange} />
                </React.Fragment>
            );
        },
        'CurrentPageReport': (options) => {
            return (
                <span style={{ color: 'var(--text-color)', userSelect: 'none', width: '120px', textAlign: 'center' }}>
                    {options.first} - {options.last} of {options.totalRecords}
                </span>
            )
        }
    };

    const renderHeader1 = () => {
        return (
            <div className="flex justify-content-between">
                <Button style={{ marginLeft: "-36rem" }} type="button" icon="pi pi-filter-slash" label="Limpiar filtros" className="p-button-outlined p-button-sm" onClick={clearFilter1} />
                <span className="p-input-icon-left">
                    <i className="pi pi-search" />
                    <InputText className="p-inputtext-sm" value={globalFilterValue1} onChange={onGlobalFilterChange1} placeholder="Palabra clave" />
                </span>
            </div>
        )
    }

    const actionBodyTemplate = (rowData) => {
        return (
            <div>
                <Button icon="pi pi-file-pdf" loading={rowStateFile[rowData.rowId]} className="p-button-danger mr-2 p-button-sm text-xs"
                    tooltip="Comprobante" tooltipOptions={{ position: 'top' }}
                    onClick={() => {
                        setRowStateFile({ ...rowStateFile, [rowData.rowId]: true });
                        generateRetefuente(rowData.rowId, rowData.ID);
                    }} />
                <Button icon="pi pi-envelope" loading={rowStateMail[rowData.rowId]} className="mr-2 p-button-sm text-xs" tooltip="Enviar por correo" tooltipOptions={{ position: 'top' }}
                    onClick={() => {
                        setRowStateMail({ ...rowStateMail, [rowData.rowId]: true });
                        sendMailVoucher(rowData.rowId, rowData.ID);
                    }} />
            </div>
        )
    }

    const onGlobalFilterChange1 = (e) => {
        /*Filtro global de la tabla*/
        const value = e.target.value;
        let _filters1 = {
            'global': { value: null, matchMode: FilterMatchMode.CONTAINS }
        };
        _filters1['global'].value = value;

        // setFilters1(_filters1);
        setGlobalFilterValue1(value);
    }

    const clearFilter1 = () => {
        initFilters1();
    }

    const initFilters1 = () => {
        /*Filtros de la tabla del componente*/
        // setFilters1({
        //     'global': { value: null, matchMode: FilterMatchMode.CONTAINS },
        //     'CONTRACT': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
        //     'NUMBER_ID': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
        //     'NAME': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
        //     'CALENDAR': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
        //     'CONCEPT': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
        //     'NAME_CONCEPT': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
        //     'TYPE_CONCEPT': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
        //     'BASE': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
        //     'REMUNER': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
        //     'REMUNER_CSO': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
        //     'UNITY': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
        //     'UND_CSO': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] }
        // });
        setGlobalFilterValue1('');
    }

    // const header1 = renderHeader1();

    // const matchModes = [
    //     { label: 'COMIENZA CON', value: FilterMatchMode.STARTS_WITH },
    //     { label: 'CONTIENE', value: FilterMatchMode.CONTAINS },
    //     { label: 'NO CONTIENE', value: FilterMatchMode.NOT_CONTAINS },
    //     { label: 'TERMINA CON', value: FilterMatchMode.ENDS_WITH },
    //     { label: 'IGUAL A', value: FilterMatchMode.EQUALS },
    //     { label: 'DIFERENTE A', value: FilterMatchMode.NOT_EQUALS }
    // ];

    // mostrar modal
    const showModal = () => {
        setIsOpen(true);
    };

    // ocultar modal
    const hideModal = () => {
        setIsOpen(false);
    };

    const rightToolbarTemplate = () => {
        return (
            <div style={{ marginRight: '1rem' }}>
                <Button icon='pi pi-search' label="Buscar" loading={loading1} onClick={() => { setLoading1(true); setTabla(retefuente) }} />
            </div>
        )
    }

    const leftToolbarTemplate = () => {
        const { NUMBER_ID, YEAR } = retefuente
        return (
            <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'flex-start' }}>
                <InputText
                    style={elementWidth}
                    id="label2"
                    type="number"
                    value={YEAR}
                    placeholder={'Año'}
                    onChange={(e) => handleChange(e.target.value, 'YEAR')}
                />
                <Dropdown
                    style={elementWidth}
                    value={NUMBER_ID}
                    options={params}
                    filter filterBy="NAME"
                    optionLabel="NAME"
                    placeholder={NUMBER_ID ? NUMBER_ID : 'Identificación*'}
                    onChange={(e) => handleChange(e.value.CODE, 'NUMBER_ID')}
                />
            </div>
        )
    }

    async function setTabla(payload) {

        try {
            await apis.getRetefuenteReports(payload, headers).then(res => {
                let data = res.data.RETENTION;
                let rowData = [];
                let statesFile = {}
                let statesMail = {}
                let rowCounter = 0;
                data.forEach(element => {
                    let e = {
                        rowId: rowCounter,
                        ...element,
                    }
                    statesFile = {
                        ...statesFile,
                        [rowCounter]: false
                    }
                    statesMail = {
                        ...statesMail,
                        [rowCounter]: false
                    }
                    rowCounter++;
                    rowData.push(e)
                })
                setRows(rowData)
                setRowStateFile(statesFile)
                setRowStateMail(statesMail)
                setLoading1(false)
                setLoadPage(true)
                toast.current.show({ severity: 'success', summary: 'Éxito', detail: 'Consulta exitosa', life: 4000 })
            })
        }
        catch (err) {
            setLoading1(false)
            setLoadPage(true)
            toast.current.show({ severity: 'warn', summary: 'Aviso', detail: err.response.data.message, life: 4000 })
        }
    }

    // generar reporte
    async function generateRetefuente(id, retefuenteId, mail = "", send = "NO") {

        const { ENTITY, CLIENT } = retefuente
        const option = '1'

        let report = {
            ENTITY,
            CLIENT,
            OPTION: option,
            SEND_MAIL: send,
            EMAIL: mail,
            KEY: retefuenteId
        }
        try {
            await apis.postRetefuenteReport(report, headers).then(res => {
                let _contenido = res.data
                setContenido(_contenido);
                setRowStateFile({ ...rowStateFile, [id]: false });
                setRowStateMail({ ...rowStateMail, [id]: false });
                setLoading3(false)
                if (send === "NO") {
                    showModal()
                }
                else {
                    toast.current.show({ severity: 'success', summary: 'Éxito', detail: "Correo enviado existosamente" })
                }
            })
        }
        catch (err) {
            setRowStateFile({ ...rowStateFile, [id]: false });
            setRowStateMail({ ...rowStateMail, [id]: false });
            setLoading3(false)
            toast.current.show({ severity: 'warn', summary: 'Aviso', detail: err.response.data.message, life: 4000 })
        }
    }

    const sendMailVoucher = async (id, voucherId) => {
        setLoading3(true)
        const mail = correo
        generateRetefuente(id, voucherId, mail, "SI")
    }

    // Cuerpo modal lista de comprobantes
    const itemTemplate = (data) => {
        let file = contenido.PDF[0].DATA
        return (
            <div className="product-item">
                {/* <img src="https://remunerwallet.s3.us-east-2.amazonaws.com/61/firma/unnamed.png" style={{ width: "50px" }} onError={(e) => e.target.src = 'https://www.primefaces.org/wp-content/uploads/2020/05/placeholder.png'} alt={data.name} /> */}
                <div className="product-detail">
                    <div className="product-name text-lg">{data.name}</div>
                    <div className="product-description">{data.description}</div>
                </div>
                <div className="product-action">
                 {contenido.PDF_OUTPUT === '1' ?
                    <Base64Downloader style={{ border: "0px", background: "transparent" }} base64={"data:application/pdf;base64," + file} downloadName="certificado" onDownloadSuccess={() => { setLoading2(false); hideModal() }}>
                        <Button icon="pi pi-arrow-down" loading={loading2} onClick={() => setLoading2(true)} />
                    </Base64Downloader>
                    :
                        <Button icon="pi pi-arrow-down" onClick={() =>  {window.open(file, "_blank"); hideModal() }} />
                    }
                </div>
            </div>
        );
    }

    // Configuración para parametros variables tipo select
    function handleChange(value, label) {
        setRetefuente({
            ...retefuente,
            [label]: value
        })
    }

    // Return que entrega la pantalla
    return (
        <div className='mt-6 flex justify-content-center align-items-center'>
            <Toast ref={toast} />

            <Dialog visible={isOpen}
                position="top" style={{ width: "36rem" }} draggable={false} resizable={false} modal onHide={hideModal}>
                <div className="datascroller-demo">
                    <div className="card">
                        <DataScroller value={listRetefuente} itemTemplate={itemTemplate} rows={5} inline scrollHeight="500px" header="Descarga el documento" />
                    </div>
                </div>
            </Dialog>

            <div class="surface-100 px-4 py-5 md:px-6 lg:px-8">
                <div class="grid">
                    <div class="col-12 ">
                        <div className="font-bold text-4xl mt-3">
                            <span className="text-900 ">Reporte retención en la fuente</span>
                        </div>
                        {localStorage.getItem('type') === 'ADMIN' &&
                            <div className='mt-4'>
                                <span style={{ fontSize: "0.8rem" }}>Campos obligatorios (*)</span>
                            </div>
                        }
                    </div>
                    <div 
                        className='card'
                        style={{
                        marginTop: '2rem',
                        width: '100%',
                    }}>
                        <SkeletonTable load={loadPage} width="90vw">
                            {localStorage.getItem('type') === 'ADMIN' && <Toolbar className="mb-1" start={leftToolbarTemplate} end={rightToolbarTemplate} />}
                            <DataTable className="text-xs" value={rows} paginator paginatorTemplate={template2} first={first2} rows={rows2} onPage={onCustomPage2}
                                selection={selectedRows} onSelectionChange={(e) => setSelectedRows(e.value)} dataKey="ID"
                                size="small">
                                <Column selectionMode="single" headerStyle={{ width: '3em' }}></Column>
                                <Column field="DESCRIPTION" headerStyle={{ width: '12rem', textAlign: 'center' }} header="Descripción"></Column>
                                <Column header="Documento" headerStyle={{ width: '12rem', textAlign: 'center' }} body={actionBodyTemplate}></Column>
                            </DataTable>
                        </SkeletonTable>
                    </div>
                </div>
            </div>
        </div>
    );
}